/**
 * Утилиты для безопасной работы с localStorage
 *
 * В Private/Incognito режиме или при переполнении квоты
 * localStorage может выбрасывать исключения.
 * Эти функции оборачивают все операции в try-catch.
 */

/**
 * Безопасное чтение значения из localStorage
 */
export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.warn(`[safeStorage] Не удалось прочитать "${key}":`, error);
    return null;
  }
}

/**
 * Безопасная запись значения в localStorage
 * @returns true если запись успешна, false при ошибке
 */
export function safeSetItem(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`[safeStorage] Не удалось записать "${key}":`, error);
    return false;
  }
}

/**
 * Безопасное удаление значения из localStorage
 * @returns true если удаление успешно, false при ошибке
 */
export function safeRemoveItem(key: string): boolean {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn(`[safeStorage] Не удалось удалить "${key}":`, error);
    return false;
  }
}

/**
 * Безопасное чтение JSON из localStorage с дефолтным значением
 */
export function safeGetJson<T>(key: string, defaultValue: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return defaultValue;
    return JSON.parse(raw) as T;
  } catch (error) {
    console.warn(`[safeStorage] Не удалось прочитать/распарсить JSON "${key}":`, error);
    return defaultValue;
  }
}

/**
 * Безопасная запись JSON в localStorage
 * @returns true если запись успешна, false при ошибке
 */
export function safeSetJson(key: string, value: unknown): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.warn(`[safeStorage] Не удалось записать JSON "${key}":`, error);
    return false;
  }
}
